import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "loading-element fixed top-0 left-0 z-50 h-screen w-screen flex items-center justify-center transition-all duration-1000 ease-in-out" }
const _hoisted_2 = { class: "relative z-30 p-10" }
const _hoisted_3 = { class: "bg-white p-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute top-0 left-0 z-20 h-full w-full bg-black opacity-80" }, null, -1)),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])), [
      [_directive_click_away, _ctx.closeModal]
    ])
  ]))
}